<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/k3rmiQ/tc-custom/9781398497306.jpg?1705688333532" alt="This image is the cover for the book The Girl on a Bike"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Girl on a Bike
      </h1>
      <p class="bookDescription body article font2">
        <p>A super-rich eminent plastic surgeon, driven insane by grief over the death of his beloved mother who was the light of his life and a celebrity in her own right. Two young, pretty, innocent schoolgirls out riding their bicycles. An FBI criminal profiler assisting a hugely built Chief Superintendent, his handsome young Inspector and attractive female detective constable. These are just some of the characters whose lives become intertwined in this fast-paced, gritty tale of abduction and murder. A gripping and page-turning epic that all tastes will enjoy from beginning to end – oh, and there are five Belgian Blue cats in the mix too. The novel has pathos, humanity and romance and a little comedy as well. It’s a must-read!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R.E. Bowden
      </h2>
      
      <p class="authorDescription body article">R.E. Bowden is a Senior Lecturer in Visual Communications at Wolverhampton University, now retired. Robert taught students on a BA (Honours) course in Graphic Design. Outside of his career, he is a keen boater and musician, acting as Musical Director for some ten shows and a member of a band. He has written several folk songs about narrow boating on canals and rivers. He is also a keen modeller and enthusiast for the hobby of model railways. He has now written five novels, including a science fiction comedy and a children’s adventure set in Animal World.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?164827fa